import React, { Component } from 'react';
import './about-us.css';

export class AboutUs extends Component {
    static displayName = AboutUs.name;

    render() {
        return (
            <div class='body'>
                <div class='about-us'>
                    <div class='about-us-text center'>
                        <h1>OUR STORY & MISSION</h1>
                        <p>At The Magical Vapors, we're dedicated to providing our valued customers with unparalleled experiences in the world of smoking alternatives. Based in Nashville, TN, and serving the greater Middle Tennessee community, we have five conveniently located stores for all your needs. Our mission is simple: bring you the highest quality products at affordable prices while maintaining exceptional customer service.</p>
                        <p>Our product selection continues to evolve to meet both our customers' needs and the requirements of applicable law. We remain dedicated to offering a thoughtfully curated range of nicotine alternatives, smoking accessories, and wellness products — all sourced from trusted suppliers and aligned with current Tennessee regulations.</p>
                        <p>When you walk into any of our Magical Vapors locations, expect nothing less than expert advice from knowledgeable staff members passionate about their craft. Whether you're new to the scene or already a seasoned connoisseur, our team will guide you through the vast universe of smoking alternatives so you leave satisfied every time. Come visit us today at one of our Nashville-area stores and discover the diverse range of products we have to offer.</p>
                    </div>
                    <div class='about-us-image'>
                        <img alt='' src='/img/about-us-image.png' />
                    </div>
                </div>
            </div>
        );
    }
}
